<template>
  <div class="container asset-po-page">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>PO管理</el-breadcrumb-item>
        <el-breadcrumb-item>资产PO确认单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="PO单号">
                <el-input v-model="searchForm.opTicketid" placeholder="请输入PO单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="机房名称">
                <el-input v-model="searchForm.idc_name" placeholder="请输入机房名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">PO确认单</div>

    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>
        <el-table
          :data="faults"
          border
          stripe
          @selection-change="handleSelectionChange"
          ref="table"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column
            v-for="(column, index) in visibleColumns"
            :key="index"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
          >
            <template slot-scope="scope">
              <span v-if="column.prop === 'opTicketid'">
                <el-button
                  type="text"
                  size="small"
                  @click="showPoServiceDetail(scope.row.opTicketid)"
                  style="color: #409eff; font-weight: 500;"
                >
                  {{ scope.row.opTicketid }}
                </el-button>
              </span>
              <span v-else-if="column.prop === 'ticket_info' || column.prop === 'resp_data'">
                <json-view-dialog
                  :content="scope.row[column.prop]"
                  :title="column.label"
                />
              </span>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog
          title="设置显示项"
          :visible.sync="showColumnsDialog"
          :append-to-body="true"
          width="400px"
          :close-on-click-modal="false"
          custom-class="columns-dialog"
          :modal-append-to-body="false"
          :destroy-on-close="true"
        >
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox
              v-for="column in columns"
              :key="column.prop"
              :label="column.prop"
              class="checkbox-item"
            >
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <!-- PO服务详情对话框 -->
        <el-dialog
          title="PO服务详情"
          :visible.sync="poServiceDetailVisible"
          width="90%"
          :before-close="closePoServiceDetail"
          append-to-body
        >
          <po-service-detail :opTicketid="selectedOpTicketid" />
          <span slot="footer" class="dialog-footer">
            <el-button @click="closePoServiceDetail">关闭</el-button>
          </span>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { assetServiceList, assetServiceAll } from '@/api/appManage';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
import PoServiceDetail from './po_service_detail.vue';
import JsonViewDialog from '@/components/JsonViewDialog';
export default {
  name: 'FaultList',
  components: {
    PoServiceDetail,
    JsonViewDialog,
  },
  data() {
    return {
      debouncedExport: null,
      faults: [],
      searchForm: {
        id: '',
        opTicketid: '',
        idc_name: '',
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: ['id', 'opTicketid', 'idc_name', 'ticket_info', 'resp_data'],
      defaultSelectedColumns: ['id', 'opTicketid', 'idc_name', 'ticket_info', 'resp_data'],
      columns: [
        { prop: 'opTicketid', label: 'PO单号' },
        { prop: 'idc_name', label: '机房名称' },
        { prop: 'ticket_info', label: '工单信息' },
        { prop: 'resp_data', label: '响应数据' },
      ],
      visibleColumns: [],
      selectedRows: [],
      machineList: [],
      loading: false,
      poServiceDetailVisible: false,
      selectedOpTicketid: ''
    };
  },
  created() {
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    this.fetchFaultData();
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    showPoServiceDetail(opTicketid) {
      this.selectedOpTicketid = opTicketid;
      this.poServiceDetailVisible = true;
    },
    closePoServiceDetail() {
      this.poServiceDetailVisible = false;
      this.selectedOpTicketid = '';
    },
    async fetchFaultData() {
      const params = {
        skip: this.currentPage,
        limit: this.pageSize,
        ...Object.fromEntries(
          Object.entries(this.searchForm).filter(
            ([_, value]) => value !== '' && value !== null && value !== undefined
          )
        ),
      };
      this.loading = true;

      try {
        // 使用常规的getPoList进行查询
        const response = await assetServiceList(params);

        if (response.data) {
          let filteredData = response.data.data.list || [];
          this.faults = filteredData;
          this.total = response.data.data.total || 0;
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleReset() {
      this.searchForm = {
        id: '',
        opTicketid: '',
        idc_name: '',
      };

      this.currentPage = 1;
      this.fetchFaultData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchFaultData();
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          this.loading = true;
          const response = await assetServiceAll({
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([_, value]) => value !== '' && value !== null && value !== undefined
              )
            ),
            pageSize: this.total || 9999999, // 确保获取所有数据
            currentPage: 1,
          });

          if (response.data) {
            this.loading = false;
            const allData = response.data.data.list || [];
            // 转换数据格式，确保与表格显示一致
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.visibleColumns.forEach((column) => {
                if (column.prop !== 'operation') {
                  // 排除操作列
                  let value = row[column.prop];
                  // 特殊字段处理，与表格显示保持一致
                  if (column.prop === 'resp_data') {
                    value = value ? JSON.stringify(value) : '-';
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            // 创建工作簿和工作表
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            // 设置列宽
            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '资产PO服务');

            // 生成文件名
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `资产PO服务_${timestamp}.xlsx`;

            // 导出文件
            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          // 导出选中数据的逻辑保持不变
          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              if (column.prop !== 'operation') {
                // 排除操作列
                let value = row[column.prop];
                if (column.prop === 'resp_data') {
                  value = value ? JSON.stringify(value) : '-';
                }
                rowData[column.label] = value || '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '资产PO服务');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `资产PO服务_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  watch: {
    selectedColumns(val) {
      this.selectAll = val.length === this.columns.length;
      this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.box-card {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button + .el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}
::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}
::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}
/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}
::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}
</style>
